import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid'
import { IUser } from '../../../../models/user'
import { useTranslation } from 'react-i18next'

interface UserTransferTableProps {
  side: string
  rows: IUser[]
  handleSelectionRows: (side: string, rows: IUser[]) => void
}

export function UserTransferTable({ side, rows, handleSelectionRows }: UserTransferTableProps) {
  const { t } = useTranslation(['global'])

  const columns: GridColDef[] = [
    { headerName: t('id'), field: 'id', width: 70 },
    { headerName: t('name'), field: 'name', flex: 1 },
    { headerName: t('email'), field: 'email', flex: 1 },
    { headerName: t('rol'), field: 'role', flex: 1 }
  ]

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '500px' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        disableColumnMenu
        checkboxSelection
        onRowSelectionModelChange={(newSelectionModel: GridRowSelectionModel) => {
          handleSelectionRows(
            side,
            rows.filter((user: IUser) => newSelectionModel.includes(user.id))
          )
        }}
      />
    </div>
  )
}
